var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slot-machine-wheel-container"},[_c('div',{staticClass:"slot-machine"},_vm._l((_vm.numWheels),function(n){return _c('SlotMachineWheel',{key:n,attrs:{"items":_vm.items[n - 1],"index":_vm.indices[n - 1],"spinning":_vm.spinning}})})),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47360d12","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlotMachine/SlotMachineWheelContainer.vue
// module id = null
// module chunks = 